import {ReactComponent as CompareArrowsIcon} from '../../../assets/icons/compare_arrows.svg'
import LanguageSelector from "./LanguageSelector";
import React from "react";
import {LanguageSwitcherContainer} from "./LanguageSwitcher.styled";
import {languages} from "../../../config/languages";
import {IconButton} from "@mui/material";
import {useTranslation} from "react-i18next";

export interface LanguageSwitcherProps {
    sourceLanguageCode: string;
    targetLanguageCode: string;
    sourceOnChange: (languageCode: string) => void;
    targetOnChange: (languageCode: string) => void;
    languageList: typeof languages;
}

const LanguageSwitcher = (props: LanguageSwitcherProps) => {
    const {t} = useTranslation();
    const handleSwitchLanguages = () => {
        props.sourceOnChange(props.targetLanguageCode);
        props.targetOnChange(props.sourceLanguageCode);
    };

    return (
        <LanguageSwitcherContainer>
            <LanguageSelector
                languageList={props.languageList}
                languageCode={props.sourceLanguageCode}
                languageSelectorType={'source'}
                dropdownListJustify={'left'}
                onChange={props.sourceOnChange}/>

            <IconButton title={t('textTranslator.switchTitle') ?? ''}
                        aria-label={t('textTranslator.switchAriaLabel') ?? ''}
                        onClick={handleSwitchLanguages}
                        sx={{color: 'secondary.light'}}
            >
                <CompareArrowsIcon />
            </IconButton>

            <LanguageSelector
                languageList={props.languageList}
                languageCode={props.targetLanguageCode}
                languageSelectorType={'target'}
                dropdownListJustify={'right'}
                onChange={props.targetOnChange}/>
        </LanguageSwitcherContainer>
    );
}

export default LanguageSwitcher;